module.exports = __webpack_public_path__ + "static/img/20170405181233_4368.c72fe16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20170405181233_4368.jpg
// module id = yF4K
// module chunks = 1